import axiosInstance from "services/common/axiosInstance";
import { RootState, store } from "store";
import { createSelector } from "reselect";
import { useSelector } from "react-redux";
import axios from "axios";

interface AddLocationApiProps {
  guid: string;
  address: string;
  activestate: true;
  latitude: string;
  longitude: string;
  state: string;
  city: string;
  district: string;
  personname: string;
  mobile: string;
  cspcode: string;
}

interface FetchLocationsApiProps {
data:any
}

interface EditLocationApiProps {
  data: AddLocationApiProps;
  params?: Record<string, any>;
}


interface DeleteLocationApiProps {
  identifiers: { guid: string }[]
}

// export const selectLayoutState = (state: RootState) => state.Login.user;
const selectLayoutState = (state: any) => state;

export const selectUser = createSelector(
  selectLayoutState,
  (state) => ({
    user: state.user
  })
);

export const selectUserGuid = createSelector(
  selectUser,
  (user: any) => user?.guid
);

const getUserGuid = (): string | undefined => {
  return selectUserGuid(store.getState());
};

// Optional helper to attach user-guid if needed
const withGuidHeader = (guid: string) => {
  return guid ? { "user-guid": guid } : {};
};


export const fetchUserApi = async (data: any) => {
  try {
    const response = await axiosInstance.post(`/reports/listallusereport`,
      data,
      {
        // headers: withGuidHeader(guid),
      }
    );
    return response.data;
  } catch (error: any) {
    throw error.response?.data || error.message;
  }
};
export const editUserApi = async (data: any) => {
  try {
    const response = await axiosInstance.post(`/usermgr/updatecustomerprofilebyadmin`,
      data,
      {
        // headers: withGuidHeader(guid),
      }
    );
    return response.data;
  } catch (error: any) {
    throw error.response?.data || error.message;
  }
};
export const fetchSingleUserApi = async (data: any) => {
  try {
    const response = await axiosInstance.post(`/reports/listallusereport`,
      data,
    );
    return response.data.users;
  } catch (error: any) {
    throw error.response?.data || error.message;
  }
};



export const addLocationApi = async (data: AddLocationApiProps, guid: string) => {
  try {
    const response = await axiosInstance.post(
      "te/auditeelocations/create-location",
      data,
      {
        headers: withGuidHeader(guid),
      }
    );
    return response.data;
  } catch (error: any) {
    throw error.response?.data || error.message;
  }
};




export const deleteMultiUserApi = async (data: {}) => {
  try {
    const response = await axiosInstance.post(
      "/usermgr/changeuserstatusbyadmin",
      data,
   
    );
    return response.data;
  } catch (error: any) {
    throw error.response?.data || error.message;
  }
};

